import { CheckIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import _ from "lodash";
import { useCallback, useEffect, useRef, useMemo } from "react";

import { useNavigate, useSearch, useMatch } from "react-location";
import { LocationGenerics } from "router/location";
import { useCurrentUser } from "_graphql/cache/auth";

import DukePaymentButton from "components/duke-payment/duke-payment";
// import {
//   addPaymentToStorefrontCart,
//   clearCart,
//   getStorefrontCart,
//   updateStorefrontCartStatus,
// } from "../../../features/cart/cart-slice";

// import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useAppDispatch, useAppSelector } from "../../../redux/store";

import { toast } from "sonner";
import { calculateAppliedDiscount } from "pages/cart/utils/checkout-calculations";
import { ICart } from "utils/types";
import { clearCart } from "../../../redux/slice/cart-slice";
import { useCreateOrder } from "../hooks/useCreateOrder";
import { useVerifyPaymentWithReference } from "../hooks/useVerifyPaymentWithReference";


const ConfirmPayment = () => {
  const navigate = useNavigate<LocationGenerics>();
  // const searchParams = useSearch<LocationGenerics>();
  const urlParams = new URLSearchParams(window.location.search);
  const reference = urlParams.get('reference');
  const isSuccessful = urlParams.get('success') === "true";
  const currentUser = useCurrentUser();
//   const { userInfo } = useAppSelector((state) => state.auth);
  const { createOrder, loading, error } = useCreateOrder();
  const { cart } = useAppSelector((state) => state.cart);
  // const { shop } = useAppSelector((state) => state.shop);
  const dispatch = useAppDispatch();

  // const reference = searchParams.reference;
  const { params } = useMatch<LocationGenerics>();
  // Destructure the order source and cart id variables from the route's dynamic params
  const [source] = JSON.parse(decodeURIComponent(params.source ?? "[]"));
  // Assign the souce to a variable
  const orderSource = source ?? "SUPPLIER CONSOLE";
  
  // const isSuccessful = searchParams.success === "true";

  const init = useRef({
    dispatch,
    cart,
    // getStorefrontCart,
    createOrder,
    navigate,
    // addPaymentToStorefrontCart,
    // updateStorefrontCartStatus,
  });
  const {
    data,
    error: errorVerifying,
    loading: verifying,
    refetch,
  } = useVerifyPaymentWithReference(reference as string);
  // const isCorrectAmount = useMemo(
  //   () => data?.amount === onlineCart?.total,
  //   [data?.amount, onlineCart?.total]
  // );

  enum OrderPaymentMethod {
    Cash = "CASH",
    PaymentOnline = "PAYMENT_ONLINE",
    PaymentOnDelivery = "PAYMENT_ON_DELIVERY",
  }
  
  enum OrderPaymentStatus {
    Paid = "PAID",
    PartiallyPaid = "PARTIALLY_PAID",
    Pending = "PENDING",
    Refunded = "REFUNDED",
    SplitPayment = "SPLIT_PAYMENT",
  }
  
  enum OrderDeliveryType {
    Delivery = "DELIVERY",
    Pickup = "PICKUP",
  }
    
  
    const isFreeDelivery = false;
  
    const _isPickup = useMemo(() => {
      return cart?.pickup != null;
    }, [cart?.pickup]);
  
    // const { totalToCollect } = useMemo(
    //   () => calculateCheckoutTotals(cart as ICart, isFreeDelivery),
    //   [cart, isFreeDelivery],
    // );
  
    // const finalAmount = useMemo(
    //   () => calculateFinalAmount(cart as ICart, isFreeDelivery),
    //   [cart, isFreeDelivery],
    // );
  
    const appliedDiscount = useMemo(
      () => calculateAppliedDiscount(cart as ICart, isFreeDelivery),
      [cart, isFreeDelivery],
    );
  
    const firstProductCurrency = cart?.products?.[0]?.currency ?? "GHS";
  
    const isPayOnDelivery =
      cart?.paymentMethod === "pay_on_delivery" ||
      cart?.paymentMethod === "pay_at_pickup";
  
    const paymentMethod = cart?.paymentMethod ?? "pay_on_delivery";

  const createSupplierOrder = useCallback(async () => {
    try {
      const {
        dispatch,
        createOrder,
        navigate,
        // addPaymentToStorefrontCart,
        // updateStorefrontCartStatus,
      } = init.current;
      const totalAmount = cart?.totalAmountToCollect as number;

    //   const orderPaymentMethod = isPayOnDelivery
    //   ? OrderPaymentMethod.PaymentOnDelivery
    //   : OrderPaymentMethod.PaymentOnline;

    // const orderPaymentStatus = isPayOnDelivery
    //   ? OrderPaymentStatus.Pending
    //   : OrderPaymentStatus.Pending;

      createOrder({
        variables: {
          input: {
            products:
              cart?.products?.map((p) => ({
                product_id: p.productSKU ?? "",
                qty: p.productQty,
                profitAdded: Number(p.profitAdded ?? 0),
                price: Number(p.newPrice ?? 0),
                discount: Number(p.discountAmount ?? 0),
              })) ?? [],
            reseller: currentUser?.id,
            total_amount: totalAmount,
            address_id: cart?.customer?.address_id,
            couponCode: cart?.coupon?.coupon?.code ?? "",
            coupon_id: cart?.coupon?.coupon_id,
            delivery_id: String(cart?.delivery?.id ?? cart?.pickup?.id ?? ""),
            delivery_type: _isPickup
              ? OrderDeliveryType.Pickup
              : OrderDeliveryType.Delivery,
            customer_id: cart?.customer?.customerId as string,
            customer_paid: true,
            source: "SUPPLIER CONSOLE",
            delivery_amount: cart?.delivery?.price ?? 0,
            discount: appliedDiscount,
            payment_status: "FULL PAYMENT",
            payment_type: "PON",
            payment_id: reference,
            supplier_id:
              _.last(cart?.products)?.supplier_id ?? undefined,
            free_delivery: isFreeDelivery,
          },
        },
        onCompleted: () => {
            dispatch(clearCart());
            navigate({
              to: `/cart/success?order_id=${createOrder}`,
              search: (old) => ({
                ...old,
                success: "true",
              }),
            });
            toast.success("Order created successfully");
        },
        onError: (err: any) => {
          toast.error("Failed to create order. Please try again.");
          console.log("Unexpected error in createStorefrontOrder:", err);
        },
      })
    } catch (error) {
      console.log("Unexpected error in createStorefrontOrder:", error);
      toast.error("Failed to create order. Please try again.");
      return false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // clearStorefrontCart,
    data?.amount,
    data?.status,
    cart?.customer?.address_id,
    cart?.delivery?.price,
    cart?.delivery?.id,
    cart?.delivery?.instantDelivery,
    // cart?.id,
    cart?.products,
    cart?.paymentMethod,
    cart?.totalAmountToCollect,
    reference,
    // shop?.ownerId,
    currentUser?.id,
  ]);

//   useEffect(() => {
//     const { dispatch, getStorefrontCart } = init.current;
//     if (isSuccessful && cart_id) {
//       dispatch(
//         getStorefrontCart({
//           id: {
//             eq: cart_id,
//           },
//         })
//       );
//     }
//   }, [cart_id, isSuccessful]);

  const storefrontOrderIsCreatedRef = useRef(false);

  useEffect(() => {
    if (
      cart &&
      !_.isEmpty(cart?.products) &&
      !storefrontOrderIsCreatedRef.current &&
      !verifying &&
      isSuccessful
    ) {
      createSupplierOrder();
      storefrontOrderIsCreatedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifying, cart, isSuccessful]);

  
  return (
    <main className="relative h-full w-full flex items-center justify-center p-5">
      <div className="overflow-hidden rounded-lg bg-white shadow w-full mx-auto md:min-w-80">
        <div className="px-4 py-5 sm:p-6">
          <div>
            {loading || verifying ? (
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-yellow-100">
                <svg
                  className="animate-spin h-6 w-6 text-yellow-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V2.5"
                  ></path>
                </svg>
              </div>
            ) : isSuccessful ? (
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                <CheckIcon
                  aria-hidden="true"
                  className="size-6 text-green-600"
                />
              </div>
            ) : !isSuccessful || errorVerifying ? (
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-yellow-100">
                <ExclamationCircleIcon
                  aria-hidden="true"
                  className="size-6 text-yellow-600"
                />
              </div>
            ) : null}
            <div className="mt-3 text-center sm:mt-5">
              {/* <h3 className="text-base font-semibold text-gray-900">
                {verifying
                  ? "Verifying payment"
                  : loading
                  ? "Creating order"
                  : isSuccessful && data?.status === "success"
                  ? "Payment successful"
                  : isSuccessful && data?.status === "initiated"
                  ? "{We're} confirming your payment"
                  : !isSuccessful || errorVerifying
                  ? data?.status === "initiated"
                    ? "Payment is pending"
                    : "Payment not completed"
                  : null}
              </h3> */}
              <div className="mt-2">
                {verifying ? (
                  <p className="text-sm text-gray-500">
                    Please, wait while we verify your payment. This will take a
                    few seconds.
                  </p>
                ) : loading ? (
                  <p className="text-sm text-gray-500">
                    Please wait! Creating your order
                  </p>
                ) : isSuccessful ? (
                  <p className="text-sm text-gray-500">
                    Thank you, the payment was successful. Your order will be
                    created and you will be redirected to your tracking number
                    shortly.
                  </p>
                ) : !isSuccessful || errorVerifying ? (
                  <p className="text-sm text-gray-500">
                    Sorry, we could not verify your payment. If you {"didn't"}
                    complete the payment, make payment or try verifying again.
                  </p>
                ) : error ? (
                  <p className="text-sm text-gray-500">
                    Sorry Order placement {"couldn't"} go through for a reason..
                    try again
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {verifying && (
          <div className="bg-gray-50 px-4 py-4 sm:px-6">
            {error ? (
              <button
                type="button"
                onClick={createSupplierOrder}
                className="inline-flex w-full justify-center rounded-md bg-[#1A93B5] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#1286A4] focus-visible:outline  focus-visible:outline-offset-2 focus-visible:outline-[#1A93B5]"
              >
                Try again
              </button>
            ) : !isSuccessful || errorVerifying ? (
              <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                <DukePaymentButton
                  text={`Pay ${firstProductCurrency} ${cart?.totalAmountToCollect?.toFixed(2)}`}
                  className="bg-[#1A93B5] p-3 hover:bg-white rounded-md hover:border hover:border-black hover:text-black text-white  w-full flex-1"
                  billingEmail={currentUser?.email || ""}
                  firstName={_.first(currentUser?.name.split(" ")) ?? ""}
                  lastName={_.last(currentUser?.name.split(" ")) ?? ""}
                  phone={currentUser?.phone ?? ""}
                  amount={cart?.totalAmountToCollect as number}
                  orderId=""
                  onCancel={() => alert("Payment not Successful")}
                  onSuccess={() => alert("Success")}
                />
                <button
                  type="button"
                  data-autofocus
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-3 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                  onClick={() =>
                    refetch({
                      input: {
                        filter: {
                          id: {
                            eq: reference as string,
                          },
                        },
                      },
                    })
                  }
                >
                  {"I've"} completed payment
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </main>
  );
};

export default ConfirmPayment;
